import { BrowserModule} from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER, ErrorHandler,CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';

import { MatDialogModule } from '@angular/material/dialog';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavigationComponent } from '../displayComponents/navigation/app/navigation.component';
import { DashboardComponent } from '../pages/dashboard/dashboard.component';
import { MessagesComponent } from '../pages/messages/messages.component';

import { LoginComponent } from '../pages/login/login.component';

import { SupportComponent } from '../pages/support/support.component';
import { CustomMaterialModule } from './material.module';
import { ToolbarComponent } from '../displayComponents/toolbar/toolbar.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatBadgeModule } from '@angular/material/badge';
import { MatStepperModule } from '@angular/material/stepper';

import { LoginService } from '../services/loginservice/login.service';

import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptors } from '@angular/common/http';
import { AuthGuardService } from '../services/auth/auth-guard.service';
import { AuthService } from '../services/auth/auth.service';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppLayoutComponent } from '../pages/layouts/applayout.component';
import { WebLayoutComponent } from '../pages/layouts/weblayout.component';
import { CommunityUpdateService } from '../services/communityupdateservice/communityupdate.service';
import { authInterceptor } from '../services/auth/authinterceptor';
import { ChatMessageService } from '../services/chatmessageservice/chatevent.service';
import { NotFoundComponent } from '../pages/notfound/notfound.component';
import { ChatseenMessageservice } from '../services/chatmessageservice/chatseenevent.service';
import { ChatRoomService } from '../services/chatmessageservice/chatroom.service';
import { SystemService } from '../services/system.service';
import { MatTableModule } from '@angular/material/table';
import {MatGridListModule} from '@angular/material/grid-list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatAutocompleteModule as MatAutocompleteModule } from '@angular/material/autocomplete';
import { EventEmitterService } from '../services/events/events.service';

import { MAT_DATE_LOCALE, MAT_DATE_FORMATS, DateAdapter} from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { CalendarComponent } from '../externals/ngx-calendar/calendar/calendar.component';
import { WebContactComponent } from '../pages/website/contact/contact.component';
import { WebHomeComponent } from '../pages/website/home/home.component';
import { WebNavigationComponent } from '../displayComponents/navigation/website/webnavigation.component';
import { WebsiteService } from '../services/website/website.services';
import { WebFooterComponent } from '../displayComponents/navigation/webfooter/webfooter.component';

import { QuillModule } from 'ngx-quill'

import { ArangoService } from '../services/arangoservice/arango.service';
import { PeopleComponent } from '../pages/people/people.component';
import { PearlsComponent } from '../pages/pearls/pearls.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { ContactFormComponent } from '../displayComponents/forms/contactForm/contactForm.component';
import { NameFormComponent } from '../displayComponents/forms/nameForm/nameForm.component';

import { PasswordFormComponent } from '../displayComponents/forms/passwordForm/passwordForm.component';
import { OtherNamesFormComponent } from '../displayComponents/forms/nameForm/otherNamesForm.component';
import { NatNumFormComponent } from '../displayComponents/forms/naturalNumberForm/naturalNumberForm.component';
import { AddressFormComponent } from '../displayComponents/forms/addressesForm/addressForm.component';
import { EmailFormComponent } from '../displayComponents/forms/emailForm/emailForm.component';
import { PersonFormComponent } from '../displayComponents/forms/personForm/personForm.component';
import { InvitesComponent } from '../pages/invites/invites.component';
import { EventsComponent } from '../pages/events/events.component';
import { CertificationComponent } from '../pages/certification/certification.component';
import { AttendeesComponent } from '../displayComponents/lists/attendeeList/attendees.component';
import { EventDBService } from '../services/events/eventdb.service';
import { PhoneFormComponent } from '../displayComponents/forms/phoneForm/phoneForm.component';
import { PearlFormComponent } from '../displayComponents/forms/pearlForm/pearlForm.component';
import { EditorComponent } from '../displayComponents/editor/editor.component';
import { UserService } from '../services/auth/session.service';
import { MatExpansionModule } from '@angular/material/expansion';
import { ActiveCampaignService } from '../services/activecampaign/activecampaign.service';
import { ActiveCampaignComponent } from '../pages/activecampaign/activecampaign.component';
import { RelationsComponent } from '../pages/relations/relations.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule as MatProgressBarModule } from '@angular/material/progress-bar';
import { MatCheckboxModule as MatCheckboxModule } from '@angular/material/checkbox';


import { SourceFormComponent } from '../displayComponents/forms/naturalNumberForm/sourceForm.component';

import { FlexLayoutModule } from "@angular/flex-layout";
import { MergePersonFormComponent } from '../displayComponents/forms/personForm/mergePersonForm.component';
import {  InviteListComponent } from '../displayComponents/lists/inviteList/inviteList.component';
import { RelationFormComponent } from '../displayComponents/forms/relationForm/relationForm.component';
import { InviteFormComponent } from '../displayComponents/forms/inviteForm/inviteForm.component';
import { RelationListComponent } from '../displayComponents/lists/relationList/relationList.component';
import { PageComponent } from '../pages/page/page.component';
import { PageFormComponent } from '../displayComponents/forms/pageForm/pageForm.component';
import { PearlDialogComponent } from '../displayComponents/dialogs/pearlDialog/pearlDialog.component';
import { InviteDialogComponent } from '../displayComponents/dialogs/inviteDialog/inviteDialog.component';
import { RelationDialogComponent } from '../displayComponents/dialogs/relationDialog/relationDialog.component';
import { SelectsService } from '../services/selects/selects.service';
import { InvitesService } from '../services/invites/invites.service';
import { SearchService } from '../services/search/search.service';
import { RelationsService } from '../services/relations/relations.service';
import { ActivityListComponent } from '../displayComponents/lists/activityList/activityList.component';
import { ActivityService } from '../services/activity/activity.service';
import { ActivityFormComponent } from '../displayComponents/forms/activityForm/activityForm.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PearlsInfoComponent } from '../displayComponents/pearlsinfo/pearlsinfo.component';
import { EventFormComponent } from '../displayComponents/forms/eventForm/eventForm.component';
import { AttendeeFormComponent } from '../displayComponents/forms/attendeeForm/attendeeForm.component';
import { SendEmailFormComponent } from '../displayComponents/forms/emailForm/individualEmails/sendEmailForm.component';
import { EmailService } from '../services/email/email.service';
import { MatCardModule as MatCardModule } from '@angular/material/card';
import { AppLoginComponent } from '../pages/website/applogin/applogin.component';
import { NotifyComponent } from '../displayComponents/notify/notify.component';
import { NotifyDialogComponent } from '../displayComponents/dialogs/notifyDialog/notifyDialog.component';
import { ProfileComponent } from '../pages/profile/profile.component';
import { PearlListComponent } from '../displayComponents/lists/pearlList/pearlList.component';
import { ProductsService } from '../services/products/products.service';
import { ProfileFormComponent } from '../displayComponents/forms/profileForm/profileForm.component';
import { HelpDialogComponent } from '../displayComponents/dialogs/helpDialog/helpDialog.component';
import { TemplateComponent } from '../pages/template/template.component';
import { TemplateFormComponent } from '../displayComponents/forms/templateForm/templateForm.component';
import { SelectListDialogComponent } from '../displayComponents/dialogs/selectListDialog/selectListDialog.component';
import { SubscriptionListComponent } from '../displayComponents/lists/subscriptionList/subscriptionList.component';
import { DeleteTemplateDialogComponent } from '../displayComponents/dialogs/deleteTemplateDialog/deleteTemplateDialog.component';
//import { TestTemplateDialogComponent } from '../displayComponents/dialogs/testTemplateDialog/testTemplateDialog.component';
import { EditorModule } from "@tinymce/tinymce-angular";

import { TemplateService } from '../services/template/template.service';
import {  SelectPersonDialogComponent } from '../displayComponents/dialogs/selectPersonDialog/selectPersonDialog.component';
import { GroupListComponent } from '../displayComponents/lists/groupList/groupList.component';
import { GroupFormComponent } from '../displayComponents/forms/groupForm/groupForm.component';
import { GroupsComponent } from '../pages/groups/groups.component';
import { GroupsService } from '../services/groups/groups.service';
import { groupDeleteDialogComponent } from '../displayComponents/dialogs/groupDialog/groupDeleteDialog.component';
import { GroupMemberListComponent } from '../displayComponents/lists/groupMemberList/groupMemberList.component';
import { OrdersComponent } from '../pages/orders/orders.component';
import { WooCommerceService } from '../services/woocommerce/woocommerce.service';
import { OrderListComponent } from '../displayComponents/lists/orderList/orderList.component';
import { SelectCustomerDialogComponent } from '../displayComponents/dialogs/selectCustomerDialog/selectCustomerDialog.component';
import { SelectNameDialogComponent } from '../displayComponents/dialogs/selectNameDialog/selectNameDialog.component';
import { HttpCancelService } from '../services/httpServices/httpcancel.service';
import { HttpCancelInterceptor } from '../services/httpServices/httpCancelInterceptor';
import { HomeComponent } from '../pages/home/home.component';
import { HomeNavComponent } from '../displayComponents/navigation/homenav/homenav.component';
import { HomeLayoutComponent } from '../pages/layouts/homelayout.component';
import { PearlService } from '../services/pearl/pearl.service';
import { SeenPearlListComponent } from '../displayComponents/lists/seenPearlList/seenPearlList.component';
import { GroupMemberFormComponent } from '../displayComponents/forms/groupMemberForm/groupMemberForm.component';
import { PartnerLayoutComponent } from '../pages/layouts/partnerlayout.component';
import { GuildMembersComponent } from '../pages/guildmembers/guildmembers.component';;
import { PartnerNavComponent } from '../displayComponents/navigation/partnernav/partnernav.component';
import { SysRolesFormComponent } from '../displayComponents/forms/sysrolesForm/sysrolesForm.component';
import { MemberService } from '../services/memberService/member.service';
import { SystemVariablesService } from '../services/systemvariables/systemvariables.service';
import { EmailCheckDialogComponent } from '../displayComponents/dialogs/emailCheckDialog/emailCheckDialog.component';
import { AffiliateFormComponent } from '../displayComponents/forms/affiliateForm/affiliateForm.component';
import { PurchaseListComponent } from '../displayComponents/lists/purchaseList/purchaseList.component';
import { PurchaseItemsListComponent } from '../displayComponents/lists/purchaseItemsList/purchaseItemsList.component';
import { ProductListComponent } from '../displayComponents/lists/productList/productList.component';
import { ProductsPageComponent } from '../pages/products/products.component';
import { AssignProductFormFormComponent } from '../displayComponents/forms/assignProductForm/assignproductForm.component';
import { UpdateProductFormFormComponent } from '../displayComponents/forms/updateProductForm/updateproductForm.component';
import { PartnerFormComponent } from '../displayComponents/forms/partnerForm/partnerForm.component';
import { ProgramItemsListComponent } from '../displayComponents/lists/programItemsList/programItemsList.component';
import { PersonalEventsComponent } from '../displayComponents/lists/personal-events-list/personal-events.component';
import { UpcomingEventsComponent } from '../displayComponents/lists/upcoming-events-list/upcoming-events.component';
import { MovementComponent } from '../pages/movement/movement.component';
import { MovementFormComponent } from '../displayComponents/forms/movementForm/movementForm.component';
import { SelectMeasurementDialogComponent } from '../displayComponents/dialogs/selectMeasurementDialog/selectMeasurementDialog.component';
import { ClientMemberListComponent } from '../displayComponents/lists/clientMemberList /clientMemberList.component';
import { ClientMemberFormComponent } from '../displayComponents/forms/clientMemberForm/clientMemberForm.component';
import { SendGroupEmailFormComponent } from '../displayComponents/forms/emailForm/groupEmails/sendGroupEmailForm.component';
import { SelectIdentificationDialogComponent } from '../displayComponents/dialogs/selectIdentificationDialog/selectIdentificationDialog.component';
import { EmailDialogComponent } from '../displayComponents/dialogs/emailDialog/emailDialog.component';
import { GuildComponent } from '../displayComponents/guild/guild.component';
import { ResourceFormComponent } from '../displayComponents/forms/resourceForm/resourceForm.component';
import { PartnerResourceListComponent } from '../displayComponents/lists/partnerResources/partnerResourceList.component';
import { MaintenanceComponent } from '../pages/maintenance/maintenance.component';
import { EmailListDialogComponent } from '../displayComponents/dialogs/emailListDialog/emailListDialog.component';
import { VideoPlayerDialogComponent } from '../displayComponents/dialogs/videoPlayerDialog/videoPlayerDialog.component';
import { VgCoreModule } from '@videogular/ngx-videogular/core';
import { VgControlsModule } from '@videogular/ngx-videogular/controls';
import { VgOverlayPlayModule } from '@videogular/ngx-videogular/overlay-play';
import { VgBufferingModule } from '@videogular/ngx-videogular/buffering';
import { CustomErrorHandlerService } from '../services/errorService/error.service';
import { VisitListComponent } from '../displayComponents/lists/visitList/visitList.component';
import { ErrorsComponent } from '../pages/errors/errors.component';
import { PrePaidMemberFormComponent } from '../displayComponents/forms/prepaidMemberForm/prepaidMemberForm.component';
import { WebScheduleComponent } from '../pages/website/schedule/schedule.component';
import { NgxRerenderModule } from 'ngx-rerender';
import { ScriptService } from '../services/scriptservice/script.service';
import { CalendlyService } from '../services/calendlyservice/calendly.service';
import { MEAListComponent } from '../displayComponents/lists/meaList/meaList.component';
import { DealsComponent } from '../pages/deals/deals.component';
import { CalendlyBookingComponent } from '../displayComponents/calendlybookings/calendlybookings.component';
import { SocialMediaFormComponent } from '../displayComponents/forms/socialForm/socialForm.component';
import { EventCalendarComponent } from '../displayComponents/calendars/eventCalendar/calendar.component';
import { AddEventDialogComponent } from '../externals/ngx-calendar/dialog/add-event-dialog/add-event-dialog.component';
import { EditEventDialogComponent } from '../externals/ngx-calendar/dialog/edit-event-dialog/edit-event-dialog.component';
import { EventDialogComponent } from '../externals/ngx-calendar/dialog/event-dialog/event-dialog.component';
import { StudentsComponent } from '../pages/students/students.component';
import { InsitututeService } from '../services/instituteService/institute.service';
import { CourseListComponent } from '../displayComponents/lists/courseList/courseList.component';
import { HoursFormComponent } from '../displayComponents/forms/hours-form/hoursForm.component';
import { AttendedListDialogComponent } from '../displayComponents/dialogs/attendedListDialog/attendedListDialog.component';
import { CreditFormComponent } from '../displayComponents/forms/creditForm/creditForm.component';
import { CreditsComponent } from '../pages/credits/credits.component';
import { CertificateListComponent } from '../displayComponents/lists/certificateList/certificateList.component';
import { CertificateDialogComponent } from '../displayComponents/dialogs/certificateDialog/certificateDialog.component';
import { SelectProductDialogComponent } from '../displayComponents/dialogs/selectProductDialog/selectProductDialog.component';
import { IdentifiedListComponent } from '../displayComponents/lists/identifiedList/identifiedList.component';
import { IdentifiedFormComponent } from '../displayComponents/forms/identifiedForm/identifiedForm.component';
import { SimpleAttendeeFormComponent } from '../displayComponents/forms/attendeeForm/simpleattendeeForm.component';
import { DupEmailList } from '../displayComponents/lists/dupEmailList/dupEmailList.component';
import { AgreementComponent } from '../pages/agreement/agreeement.component';
import { agreementFormComponent } from '../displayComponents/forms/agreementForm/agreementForm.component';
import { AgreementService } from '../services/agreementservice/agreement.service';
import { AgreementDialogComponent } from '../displayComponents/dialogs/agreementDialog/agreementDialog.component';
import  {  PdfViewerModule  }  from  'ng2-pdf-viewer';
import { DirectoryComponent } from '../displayComponents/lists/directoryList/directory.component';
import { AssertedComponent } from '../displayComponents/lists/attendeeList/asserted.component';
import { NgxMatFileInputComponent, NgxMatFileInputIcon } from '../displayComponents/forms/fileInputForm/file-input.component';
import { MatIconModule } from '@angular/material/icon';

/* Add Amplify imports 
import { AmplifyUIAngularModule } from '@aws-amplify/ui-angular';
import Amplify from 'aws-amplify';
import awsconfig from '../aws-exports';

//Configure Amplify resources 
Amplify.configure(awsconfig);

*/
@NgModule({
  declarations: [
    AppComponent,
    NavigationComponent,
    VideoPlayerDialogComponent,
    HomeNavComponent,
    WebNavigationComponent,
    WebFooterComponent,
    DashboardComponent,
    MEAListComponent,
    DirectoryComponent,
    AssertedComponent,
    HomeComponent,
    HomeLayoutComponent,
    MessagesComponent,
    NotifyComponent,
    WebContactComponent,
    WebHomeComponent,
    NotifyDialogComponent,
    EventCalendarComponent,
    HoursFormComponent,
    SocialMediaFormComponent,
    WebHomeComponent,
    SimpleAttendeeFormComponent,
    ActivityFormComponent,
    LoginComponent,
    SupportComponent,
    CalendlyBookingComponent,
    ToolbarComponent,
    AppLayoutComponent,
    WebLayoutComponent,
    ResourceFormComponent,
    PartnerResourceListComponent,
    MaintenanceComponent,
    OrdersComponent,
    NotFoundComponent,
    PeopleComponent,
    PearlsComponent,
    PageComponent,
    AppLoginComponent,
    ErrorsComponent,
    PageFormComponent,
    ContactFormComponent,
    NameFormComponent,
    AddressFormComponent,
    EmailDialogComponent,
    SelectIdentificationDialogComponent,
    PurchaseListComponent,
    ProductListComponent,
    SendGroupEmailFormComponent,
    SysRolesFormComponent,
    OtherNamesFormComponent,
    PasswordFormComponent,
    PurchaseItemsListComponent,
    DupEmailList,
    EmailFormComponent,
    PartnerNavComponent,
    PhoneFormComponent,
    NatNumFormComponent,
    RelationListComponent,
    RelationsComponent,
    agreementFormComponent,
    AffiliateFormComponent,
    PersonFormComponent,
    MergePersonFormComponent,
    RelationListComponent,
    PartnerLayoutComponent,
    GuildComponent,
    GuildMembersComponent,
    RelationFormComponent,
    AgreementComponent,
    InviteFormComponent,
    PearlFormComponent,
    EditorComponent,
    InvitesComponent,
    EventsComponent,
    CertificationComponent,
    AttendeesComponent,
    ActiveCampaignComponent,
    SourceFormComponent,
    AttendedListDialogComponent,
    EventFormComponent,
    InviteListComponent,
    SubscriptionListComponent,
    AttendeeFormComponent,
    ActivityListComponent,
    PearlDialogComponent,
    InviteDialogComponent,
    TemplateComponent,
    SelectProductDialogComponent,
    SelectMeasurementDialogComponent,
    TemplateFormComponent,
    //TestTemplateDialogComponent,
    ClientMemberListComponent,
    ClientMemberFormComponent,
    DeleteTemplateDialogComponent,
    ProgramItemsListComponent,
    PersonalEventsComponent,
    MovementFormComponent,
    UpcomingEventsComponent,
    MovementComponent,
    HelpDialogComponent,
    EmailListDialogComponent,
    GroupListComponent,
    DealsComponent,
    GroupFormComponent,
    GroupsComponent,
    GroupMemberListComponent,
    groupDeleteDialogComponent,
    PartnerFormComponent,
    OrderListComponent,
    ClientMemberListComponent,
    CourseListComponent,
    UpdateProductFormFormComponent,
    ProfileFormComponent,
    CreditFormComponent,
    CreditsComponent,
    CertificateListComponent,
    AssignProductFormFormComponent,
    RelationDialogComponent,
    AddEventDialogComponent,
    EditEventDialogComponent,
    EventDialogComponent,
    StudentsComponent,
    SelectListDialogComponent,
    IdentifiedListComponent,
    GroupMemberFormComponent,

    ProductsPageComponent,
    SelectPersonDialogComponent,
    EmailCheckDialogComponent,
    CertificateDialogComponent,
    SelectNameDialogComponent,
    CalendarComponent,
    WebScheduleComponent,
    SelectCustomerDialogComponent,
    AgreementDialogComponent,
    PrePaidMemberFormComponent,
    VisitListComponent,
    SendEmailFormComponent,
    IdentifiedFormComponent,
    PearlsInfoComponent,
    ProfileComponent,
    PearlListComponent,
    SeenPearlListComponent
  ],
  imports: [
    FlexLayoutModule,
 //   AmplifyUIAngularModule, /* Add Amplify module */
    VgCoreModule,
    VgControlsModule,
     VgOverlayPlayModule,
    VgBufferingModule,
    BrowserModule,
    NgxMatFileInputComponent,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    NgxRerenderModule,
    MatProgressBarModule,
    AppRoutingModule,
    NgxMatFileInputIcon,
    MatMenuModule,
    MatAutocompleteModule,
    EditorModule,
    PdfViewerModule,
    MatCheckboxModule,
    MatBadgeModule,
    MatTableModule,
    MatCardModule,
    MatGridListModule,
    ClipboardModule,
    MatTooltipModule,
    MatDialogModule,
    MatCheckboxModule,
    MatExpansionModule,
    FlexLayoutModule,
    MatButtonToggleModule,
    MatPaginatorModule,
    MatSortModule,
    MatStepperModule,
MatIconModule,
    CustomMaterialModule,
    FormsModule,
    NgxPaginationModule,
    QuillModule.forRoot({
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'],
          ['blockquote', 'code-block'],
          [{ 'color': [] }, { 'background': [] }],
          [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
          [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
          [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
          [{ 'list': 'ordered'}, { 'list': 'bullet' }],
          [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
          [ 'link', 'image', 'video', 'formula' ],
        ]
      }
    })
  ],
  providers: [
    AgreementService,
   EventEmitterService,
   EventDBService,
   LoginService,
   UserService,
   SystemService,
   CalendlyService,
   ScriptService,
   InsitututeService,
   SystemVariablesService,
   ProductsService,
   PearlService,
   MemberService,
   HttpClient,
   TemplateService,
   SearchService,
   EmailService,
   InvitesService,
   ArangoService,
   WooCommerceService,

   RelationsService,
   AuthGuardService,
   ActivityService,
   AuthService,

   SelectsService,
   CommunityUpdateService,
   GroupsService,
   ChatMessageService,
   ChatseenMessageservice,
   ChatRoomService,
   WebsiteService,
   ActiveCampaignService,
   HttpCancelService,
   provideHttpClient(
    withInterceptors([authInterceptor]) // Register it here
  ),
  {
    multi: true,
    provide: HTTP_INTERCEPTORS,
    useClass: HttpCancelInterceptor
  },
  {
    provide: MAT_DATE_FORMATS,
    useValue: {
      parse: {
        dateInput: ['YYYY-MM-DD'],
      },
      display: {
        dateInput: 'YYYY-MM-DD',
        monthYearLabel: 'YYYY-MM',
        dateA11yLabel: 'YYYY-MM-DD',
        monthYearA11Label: 'YYYY-MM-DD'
      }
    }
  },
    {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {floatLabel: 'always'}},
    {provide: ErrorHandler, useClass: CustomErrorHandlerService},
  ],
  exports : [
  ],

  bootstrap: [AppComponent]
})
export class AppModule { }
export class AppLoadModule { }
